import React from 'react';
import {Box, Switch, Typography} from '@mui/material';
import {useInput} from 'react-admin';
import {t} from '../../themes/statamicTokens';

const ToggleRow = ({source, label, subtitle, defaultValue = false}) => {
    const {field} = useInput({source, defaultValue});
    const checked = Boolean(field.value);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                gap: 2,
                py: 1.25,
                '& + &': { borderTop: `1px solid ${t.color.border.hairline}` },
            }}
        >
            <Box sx={{minWidth: 0}}>
                <Typography
                    sx={{
                        fontSize: `${t.type.bodyStrong.size}px`,
                        fontWeight: 500,
                        color: t.color.text.primary,
                        lineHeight: 1.3,
                    }}
                >
                    {label}
                </Typography>
                {subtitle && (
                    <Typography
                        sx={{
                            fontSize: `${t.type.caption.size}px`,
                            color: t.color.text.secondary,
                            mt: 0.25,
                        }}
                    >
                        {subtitle}
                    </Typography>
                )}
            </Box>
            <Switch
                checked={checked}
                onChange={(e) => field.onChange(e.target.checked)}
                sx={{
                    flexShrink: 0,
                    '& .MuiSwitch-switchBase.Mui-checked': {
                        color: t.color.accent.primary,
                    },
                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: t.color.accent.primary,
                    },
                }}
            />
        </Box>
    );
};

export default ToggleRow;
